<template>
  <common-dialog v-bind="$attrs" v-on="$listeners" ref="commonDialogRef" title="提示">
    <div class="unit-dialog">
      <div class="contact">
        <div class="main-title"> 如您想成为生态单位，请下载提交申请表并与我们工作人员取得联系，您的相关咨询我们将尽快回复</div>
        <div class="flex-start" style="margin-bottom: 12px">
          <img src="~@/assets/img/join/weixin.png" alt="">
          <span>ITGSA-BD</span>
        </div>
        <div class="flex-start">
          <img src="~@/assets/img/join/email.png" alt="">
          <span>service@itgsa.com</span>
        </div>
      </div>
      <div class="process">
        <div class="main-title"> 加入流程</div>
        <div class="process-content flex-nowrap">
          <div v-for="(item,index) in process" :key="index" class="flex-column relative">
            <img class="icon" :src="item.pic" alt="">
            <img class="arrow absolute" v-if="index + 1 !== process.length"
                 src="~@/assets/img/service/process_arrow.png"
                 alt="">
            <span class="step color-level2 fontWeight-500">STEP 0{{ index + 1 }}</span>
            <span class="color-level1 font-blod">{{ item.title }}</span>
          </div>
        </div>
      </div>
      <a class="btn cursor fontWeight-500 color-level2" href="/移动智能终端生态联盟-生态单位申请表.docx">下载申请表</a>
    </div>
  </common-dialog>
</template>
<script>
import CommonDialog from "@/components/common/CommonDialog.vue";

export default {
  components: {
    CommonDialog
  },
  data() {
    return {
      process: [
        {title: '邮箱提交申请', pic: require('@/assets/img/join/unit-process-1.png')},
        {title: '秘书处评定', pic: require('@/assets/img/join/unit-process-2.png')},
        {title: '秘书长审核', pic: require('@/assets/img/join/unit-process-3.png')},
        {title: '正式加入', pic: require('@/assets/img/join/unit-process-4.png')},
      ]
    }
  },
  methods: {
    showDialog() {
      this.$refs.commonDialogRef.showDialog()
    },
    closeDialog() {
      this.$refs.commonDialogRef.closeDialog()
    }
  }
}
</script>


<style scoped lang="scss">
.unit-dialog {
  .main-title {
    height: 24px;
    line-height: 24px;
    font-weight: bold;
    font-size: 14px;
    color: $color-level1;
    display: flex;
    align-items: center;
    margin-bottom: 24px;

    &:before {
      content: '';
      display: inline-block;
      width: 4px;
      height: 24px;
      background: $color-main1;
      margin-right: 12px;
    }
  }

  .contact {
    margin-bottom: 32px;

    img {
      margin-right: 12px;
      width: 32px;
      height: 32px;
    }
  }

  .process {
    &-content {

      & > div:not(:last-child) {
        width: 168px;


      }
      .icon {
        width: 40px;
        height: 40px;
      }

      .arrow {
        width: 48px;
        height: 12px;
        left: 80px;
        top: 15px;
      }

      .step {
        margin: 16px 0 4px;
        line-height: 24px;
        height: 24px;
      }
    }
  }

  .btn {
    display: block;
    margin: 60px auto 0;
    width: 240px;
    height: 40px;
    line-height: 40px;
    border-radius: 38px 38px 38px 38px;
    border: 1px solid #B3B3B3;
    text-align: center;
    &:hover {
      color: $color-level1;
      background: linear-gradient( 90deg, #F5CE99 0%, #FFF2C6 52%, #F5CE99 100%);
      border: 1px solid transparent;
    }
  }
}
</style>
